import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  TextField,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Chip,
  Button,
  Alert,
  CircularProgress,
} from '@mui/material';
import { PlayArrow as PlayArrowIcon } from '@mui/icons-material';
import type { ExecuteVorlageDialogProps } from './types';

const ExecuteVorlageDialog: React.FC<ExecuteVorlageDialogProps> = ({
  open,
  onClose,
  vorlage,
  workflowName,
  onWorkflowNameChange,
  onExecute,
  isExecuting,
}) => {
  if (!vorlage) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box display="flex" alignItems="center" gap={1}>
          <PlayArrowIcon color="primary" />
          Workflow aus Vorlage starten
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box>
          <Alert severity="info" sx={{ mb: 2, mt: 1 }}>
            Sie starten einen neuen Workflow basierend auf der Vorlage "<strong>{vorlage.name}</strong>".
          </Alert>

          <Typography variant="body2" sx={{ mb: 2 }}>
            Diese Vorlage enthält <strong>{vorlage.schritte.length} Schritte</strong> in der Kategorie "{vorlage.kategorie}".
          </Typography>

          <TextField
            fullWidth
            label="Workflow-Name (optional)"
            value={workflowName}
            onChange={(e) => onWorkflowNameChange(e.target.value)}
            placeholder={`${vorlage.name} - ${new Date().toLocaleDateString('de-DE')}`}
            helperText="Leer lassen für automatischen Namen"
            sx={{ mt: 2 }}
          />

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" gutterBottom>
            Vorschau der Schritte:
          </Typography>
          <List dense>
            {vorlage.schritte.map((schritt) => (
              <ListItem key={schritt.schrittNummer} disablePadding sx={{ py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <Chip label={schritt.schrittNummer} size="small" />
                </ListItemIcon>
                <ListItemText
                  primary={schritt.titel}
                  secondary={schritt.was.length > 100 ? schritt.was.substring(0, 100) + '...' : schritt.was}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Abbrechen</Button>
        <Button
          variant="contained"
          onClick={onExecute}
          disabled={isExecuting}
          startIcon={isExecuting ? <CircularProgress size={16} /> : <PlayArrowIcon />}
          color="primary"
        >
          {isExecuting ? 'Startet...' : 'Workflow starten'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExecuteVorlageDialog;
